import { Component, inject } from '@angular/core';
import { SeatDefinition } from '@core/models';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  standalone: false,
  selector: 'app-seat-definitions-modal',
  templateUrl: './seat-definitions-modal.component.html',
  styleUrl: './seat-definitions-modal.component.scss',
})
export class SeatDefinitionsModalComponent {
  definitions: SeatDefinition[];
  isAda: boolean;
  seatId: string;
  title = 'Seat Definitions';
  public bsModalRef = inject(BsModalRef);

  close() {
    this.bsModalRef.hide();
  }

  get seatSection() {
    return this.seatId.split('-')[0].split('_')[1];
  }

  get seatRow() {
    return this.seatId.split('-')[1];
  }

  get seat() {
    return this.seatId.split('-')[2];
  }
}
